import apiHandler from '../../utilities/apiHandler.js';

const LoginApiHandler = {

	loginWithToken: function (tokenId) {
		var URL = "login/validate-token?tokenID="+tokenId;
        return apiHandler.post(URL);
    }

}

export default LoginApiHandler;


// WEBPACK FOOTER //
// ./src/screens/Login/LoginApiHandler.js